const $ = window.jQuery;
const OFFSET = 50;

export default new class {
  constructor() {
    this.selectors = {
      link: '.js-scroll-to',
    };

    $(document).ready(() => {
      this.init();
    });
  }

  init() {
    this.bindClickEvent();
  }

  bindClickEvent() {
    const link = $(this.selectors.link);
    link.on('click', event => {
      event.preventDefault();

      const target = link.attr('href');
      const $target = $(target);

      window.scroll({
        top: $target.offset().top - OFFSET,
        left: 0,
        behavior: 'smooth',
      });
    });
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/scroll-to.js